import { PureComponent } from 'preact-compat'

import { approveReply, approveTopic } from '../services/topicService'

/* eslint-disable import/no-internal-modules */
import { ContentType } from '@insided/shared/utils/contentType'
import ButtonControl from '@insided/deprecated-preact-components/button-control'

export interface ApproveProps {
  contentType: ContentType
  topicId?: number
  replyId?: number
  onApprove: () => void
  onShowAlert: (type: 'success' | 'error', message?: string) => void
}

class Approve extends PureComponent<ApproveProps> {
  constructor (props: ApproveProps) {
    super(props)
    this.approve = this.approve.bind(this)
  }

  async approve () {
    const { contentType, topicId, replyId, onApprove, onShowAlert } = this.props

    try {
      if (replyId) {
        await approveReply(contentType, replyId)
      } else if (topicId) {
        await approveTopic(contentType, topicId)
      }
      onApprove()
      onShowAlert('success', 'You`ve approved this post.')
    } catch {
      onShowAlert('error')
    }
  }

  render () {
    return (
      <ButtonControl
        title='Approve'
        variant='success'
        onClick={this.approve}
        // eslint-disable-next-line @gorazdo/preact/prefer-classname
        class='qa-approve'
      />
    )
  }
}

export default Approve
